<main>
  <div class="status-list">
    <div class="status-long-item">
      <div class="status-header">TOTAL AUTHORIZED FUNDS</div>
      <div class="item">${{totalFunding | number:'1.2-2'}}</div>
    </div>
    <div class="status-long-item">
      <div class="status-header">% EXPENDITURES</div>
      <div class="item">{{totalCompletedFunding / totalFunding * 100 | number:'1.0-0'}} %</div>
    </div>
  </div>
  <div class="header-row">
    <div class="titles">
      <h1>Accomplishment Reports</h1>
      <h3>{{accomplishment_reports.length ?? 0}} Report(s)</h3>
    </div>
    <button class="usa-button longer-button" (click)="createAccomplishReport()"
      [disabled]="!canCreate"><mat-icon>add</mat-icon> Create
    Accomplishment Report</button>
  </div>
  <table mat-table [dataSource]="accomplishment_reports" class="center">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Report Name</th>
      <td mat-cell *matCellDef="let report">
        @if(report.submitted) {
          <a [routerLink]="'/view-report-accomplishment'"
          [queryParams]="{accomplishment_id: report.accomplishment_id}">{{report.report_name}}</a>
        }
        @else {
        <a [routerLink]="'/report-accomplishment'"
        [queryParams]="{accomplishment_id: report.accomplishment_id}">{{report.report_name}}</a>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="action_type">
    <th mat-header-cell *matHeaderCellDef>Action Type</th>
    <td mat-cell *matCellDef="let report" class="prewrap">
      {{report.report_type}} report
    </td>
  </ng-container>
  <ng-container matColumnDef="submission_date">
    <th mat-header-cell *matHeaderCellDef>Submission Date</th>
    <td mat-cell *matCellDef="let report" class="prewrap">
      @if(report.submitted) { {{report.submitted_on | date:"MM/dd/yyyy"}} }
        @else { -- }
      </td>
    </ng-container>
    <ng-container matColumnDef="submitted_by">
      <th mat-header-cell *matHeaderCellDef class="align-right">Submitted By</th>
      <td mat-cell *matCellDef="let report" class="align-right">
        @if(report.submitted) { {{report.submitted_by}} }
          @else { -- }
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="align-right">Status</th>
        <td mat-cell *matCellDef="let report" class="align-right">
          @if(report.submitted) {
            <mat-chip class="chip-4">
              <span class="chip-text">{{4 | statusBadge}}</span>
            </mat-chip>
          }
          @else {
          <mat-chip class="chip-3">
            <span class="chip-text">{{3 | statusBadge}}</span>
          </mat-chip>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="align-right">Actions</th>
      <td mat-cell *matCellDef="let report" class="align-right">
        @if (!report.submitted) {
          <button class="edit-report" [routerLink]="'/report-accomplishment'"
            [queryParams]="{accomplishment_id: report?.accomplishment_id}">
            <fa-icon class="fa-sm" [icon]="faEdit"></fa-icon>Edit Report
          </button>
        }
        @if (report.submitted) {
          <button class="edit-report" [routerLink]="'/view-report-accomplishment'"
            [queryParams]="{accomplishment_id: report?.accomplishment_id}">
            <fa-icon class="fa-sm" [icon]="faFileLines"></fa-icon>View Report
          </button>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="13">
        <div class="no-data">
          <div class="no-data-icon">
            <img class="no-data-icon3" src="assets/img/empty-state-page.svg" alt="No Reports">
          </div>
          <div class="no-data-title">No Reports Have Been Created</div>
        </div>
      </td>
    </tr>
  </table>
</main>